import { ReactNode, useState } from 'react';
import styles from './ToggleMenu.module.css';

export interface ToggleMenuItem {
  key: string | number;
  title: ReactNode;
  body: ReactNode;
}

export interface ToggleMenuProps {
  items: ToggleMenuItem[];
  footerBody?: ReactNode;
  className?: string;
}

export default function ToggleMenu({
  items,
  footerBody,
}: ToggleMenuProps) {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleToggle = (idx: number) => {
    setActiveIndex(idx);
  };

  return (
    <div
      className={styles.toggleMenu}
    >
      <div className={styles.titleOptions} role="tablist">
        {items.map((item, idx) => (
          <div
            key={item.key}
            id={`tab-${idx}`}
            role="tab"
            aria-controls={`panel-${idx}`}
            aria-selected={activeIndex === idx}
            tabIndex={activeIndex === idx ? 0 : -1}
            className={`${styles.title} ${
              activeIndex === idx ? styles.selected : ''
            }`}
            onClick={() => handleToggle(idx)}
          >
            {item.title}
          </div>
        ))}
      </div>

      {items.map((item, idx) => (
        <div
          key={item.key}
          id={`panel-${idx}`}
          role="tabpanel"
          aria-labelledby={`tab-${idx}`}
          hidden={activeIndex !== idx}
          className={styles.body}
        >
          {item.body}
          {footerBody}
        </div>
      ))}
    </div>
  );
}